import { AxiosError, AxiosResponse, default as axios } from 'axios';
import * as status from 'http-status-codes';
import { BusinessUnit } from '../Model';
import { logError } from './ecommscriptClient';

const api = `${process.env.REACT_APP_B2bApiUrl}/v1/business-units`;

export const getBusinessUnit = (businessUnitId: string): Promise<BusinessUnit> => {
    const headers = {
        ApiKey: process.env.REACT_APP_B2bApiKey,
        Accept: 'application/json',
    };
    return axios
        .get(`${api}/${businessUnitId}`, { headers })
        .then((response: AxiosResponse) => {
            if (response.status === status.OK) {
                return response.data;
            } else {
                throw new Error(`Failed to get business unit. Reason: ${response.data}`);
            }
        }).catch((err: AxiosError) => {
            logError(err);
            return Promise.resolve({ id: '' });
        });
};



// WEBPACK FOOTER //
// ./src/Api/businessUnitClient.ts